import { Helmet } from 'react-helmet-async';
// sections
import Login from '../../../sections/auth/mediator/Login';

// ----------------------------------------------------------------------

export default function LoginPage() {
  return (
    <>
      <Helmet>
        <title>Accesso Mediatore | Portale Mediatori Sanitari</title>
      </Helmet>

      <Login />
    </>
  );
}
